(function(){
  const modal   = document.querySelector('[data-offerte-modal]');
  const openBtn = document.querySelector('[data-offerte-open]');
  const closers = document.querySelectorAll('[data-offerte-close]');

  if(!modal || !openBtn) return;

  function open(){ modal.hidden = false; modal.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  function close(){ modal.hidden = true; modal.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }

  openBtn.addEventListener('click', open);
  closers.forEach(el => el.addEventListener('click', close));
  document.addEventListener('keydown', (e)=>{ if(e.key==='Escape') close(); });

  // optioneel: quantity van product meenemen
  const qtyInput = document.querySelector('input[name="quantity"], #Quantity-Input, .quantity__input');
  const qtyHidden = modal.querySelector('[data-offerte-qty]');
  if(qtyInput && qtyHidden){
    const sync = ()=> qtyHidden.value = qtyInput.value || 1;
    qtyInput.addEventListener('input', sync); sync();
  }
})();

function bindOfferteTrigger(){
  var openBtn = document.getElementById('offerte-open');
  var hidden  = document.getElementById('offerte-hidden-trigger');
  if (openBtn && hidden){
    if (!openBtn.__offerteBound) {
      openBtn.addEventListener('click', function(e){
        e.preventDefault();
        hidden.click(); // opent Shopify Forms popup 730820
      });
      openBtn.__offerteBound = true;
    }
  }
}
document.addEventListener('DOMContentLoaded', bindOfferteTrigger);
document.addEventListener('shopify:section:load', bindOfferteTrigger);
